/**
 * PostHog — opt-in, отложенная загрузка после React.
 * us-assets.i.posthog.com из РФ часто pending; без ENABLE_POSTHOG=true не грузим array.js.
 */

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const SCRIPT_TIMEOUT_MS = 4000;

export function isPosthogEnabled() {
  return process.env.REACT_APP_ENABLE_POSTHOG === 'true' && Boolean(POSTHOG_KEY);
}

function posthogAssetsHost(apiHost) {
  return apiHost.replace('.i.posthog.com', '-assets.i.posthog.com');
}

function loadScriptWithTimeout(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.src = src;

    let settled = false;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      script.onload = null;
      script.onerror = null;
      fn(value);
    };

    const timer = setTimeout(() => {
      script.remove();
      finish(reject, new Error('PostHog script timeout'));
    }, SCRIPT_TIMEOUT_MS);

    script.onload = () => finish(resolve);
    script.onerror = () => {
      script.remove();
      finish(reject, new Error('PostHog script error'));
    };

    document.head.appendChild(script);
  });
}

/** Очередь _i + array.js с таймаутом (как официальный snippet, но без бесконечного pending). */
async function bootPosthog() {
  if (window.__posthogBooted) return;
  window.__posthogBooted = true;

  const ph = window.posthog || [];
  window.posthog = ph;
  ph._i = ph._i || [];
  ph._i.push([
    POSTHOG_KEY,
    {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      disable_session_recording: true,
      disable_surveys: true,
      capture_performance: false,
      autocapture: true,
    },
  ]);

  try {
    await loadScriptWithTimeout(
      `${posthogAssetsHost(POSTHOG_HOST)}/static/array.js`,
    );
  } catch {
    window.posthog = undefined;
    window.__posthogBooted = false;
  }
}

function scheduleIdle(fn) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fn, { timeout: 5000 });
  } else {
    setTimeout(fn, 2000);
  }
}

export function initPosthogDeferred() {
  if (typeof window === 'undefined') return;
  if (!isPosthogEnabled()) return;
  if (window.__posthogDeferredInit) return;
  window.__posthogDeferredInit = true;

  const start = () => scheduleIdle(() => {
    bootPosthog().catch(() => {});
  });

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
}
